angular
    .module('festzelt-os.vouchers.templates')
    .factory('VoucherTemplate', [
        'locale',
        'Resource',
        VoucherTemplate
    ]);

function VoucherTemplate(locale, Resource) {
    const $model = Resource.make('vouchers/templates');

    $model.locales = ['common', 'vouchers'];

    return $model;
}



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/templates/factories/voucher-template-factory.js